import closeDelete from '@/assets/images/closeDelete.svg';
import styles from './ItemDetailsSkeleton.module.scss';

interface ItemDetailsSkeletonProps {
  onClose: () => void;
}

const ItemDetailsSkeleton = ({ onClose }: ItemDetailsSkeletonProps) => {
  return (
    <div className={styles.itemDetailsModalSkeleton}>
      <div className={styles.modalWrapper}>
        <div className={styles.closeButton} onClick={onClose}>
          <img src={closeDelete} alt="Close" />
        </div>
        <div className={styles.itemDetailsSkeleton}>
          <div className={styles.imageWrapper} />
          <div className={styles.contentWrapper}>
            <div className={styles.title} />
            <div className={styles.description} />
            <div className={styles.price} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetailsSkeleton;
